import { render, staticRenderFns } from "./program-record-due.vue?vue&type=template&id=29b71152&lang=pug&"
import script from "./program-record-due.vue?vue&type=script&lang=js&"
export * from "./program-record-due.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports